import { useNavigate } from "react-router-dom";
import settings from "../../../configs/settings";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextareaAutosize,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import Message from "../../../project/utils/Message";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Check from "@mui/icons-material/Check";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { useContext, useState, useEffect } from "react";

import { saveGestionAtencion } from "../../../project/services/GestionAtencionService";
import { getAreas } from "../../../project/services/AreaService";
import { getMotivosVentaNoConcretada } from "../../../project/services/MotivoVentaNoConcretadaService";

import { getCacheData } from "../../services/CacheService";

import { format } from "date-fns";
import Item from "../../utils/Item";
import { formatMoney } from "../../utils/utils"

import AuthContext from "../../contexts/AuthContext";

// 
// ################################################################################
//
const Finalizar = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [areas, setAreas] = useState([]);
  const [motivosVentaNoConcretada, setMotivosVentaNoConcretada] = useState([]);

  const { hasPermission } = useContext(AuthContext);
  const _crearGestionAtencion = hasPermission("gestion-comercial-c");
  const _editarGestionAtencion = hasPermission("gestion-comercial-e");

  const {
    setIsDoingSomething,
    isSetClient,
    validarDatosCliente,
    anteojos,
    arreglos,
    productosRows,
    lentesContactoRows,
    recetaLejos,
    recetaCerca,
    recetaIntermedia,
    validarDatosReceta,
    prepararGestionAtencionObject,
    gaAction,
    finalizar,
    setFinalizar,
    valueACAreaEntrega,
    setvalueACAreaEntrega,
    inputvalueACAreaEntrega,
    setInputvalueACAreaEntrega,
    particularObraSocial,
    disabledGestionParticularObraSocial,
    disabledTotalFinalGestionAtencion,
    disabledConfirmarGestionAtencion,
    disabledModificarGestionAtencion,
    gestionAtencionConfirmada,
    ventaConcretadaNoConcretada,
    disabledVentaConcretadaNoConcretada,
    emiteNoEmitePresupuesto,
    handleChangeFinalizar,
    handleChangeFechaEntrega,
    handleBlurFinalizar,
    handleChangeParticularObraSocial,
    handleChangeVentaConcretadaNoConcretada,
    handleChangeEmiteNoEmitePresupuesto,
    confirmarGestionAtencion,
    modificarGestionAtencion,
    disabledGuardarGA,
    sucursalGA,
    usuarioGA,
    fechaCreacionGA,
  } = useContext(GestionAtencionContext);

  const {
    subTotalGestionAtencion,
    totalFinalGestionAtencion,
    areaEntrega,
    descripcionAreaEntrega,
    fechaEntrega,
    motivoVentaNoConcretada,
    descripcionMotivoVentaNoConcretada,
    detalleVentaNoConcretada,
    textoPresupuesto,
  } = finalizar;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
    loadMotivosVentaNoConcretada();
  }, []);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "punto-de-venta");
      setAreas(_response);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadMotivosVentaNoConcretada = async () => {
    const response = await getCacheData('motivo_venta_no_concretada');
    if (response.ok) {
      setMotivosVentaNoConcretada(response.data.data);
    } else {
      setMotivosVentaNoConcretada([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setFinalizar({
      ...finalizar,
      areaEntrega: valueACAreaEntrega.id ? valueACAreaEntrega.id : areaEntrega,
    });
  }, [valueACAreaEntrega]);
  //
  // ################################################################################
  //
  const handleClickConfirmarGestionAtencion = () => {
    // valido datos globales de la gestion de atencion

    let _error;

    if (!isSetClient) {
      // si no se ha indicado el cliente

      setMessage({
        messageText: "Debes indicar el Cliente",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // valido datos de cliente
    _error = validarDatosCliente();

    if (!_error.error) {
      setMessage({
        messageText: _error.messageText,
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // determino si hay anteojos y si al menos hay uno seleccionado
    let _hayAnteojos = false;
    anteojos.every((item) => {
      if (item.selectedAnteojo) {
        _hayAnteojos = true;
        return false;
      }
      return true;
    });

    // determino si hay arreglos y si al menos hay uno seleccionado
    let _hayArreglos = false;
    arreglos.every((item) => {
      if (item.selectedArreglo) {
        _hayArreglos = true;
        return false;
      }
      return true;
    });

    // determino si hay otros productos y si al menos hay uno seleccionado
    let _hayProductos = false;
    productosRows.every((item) => {
      if (item.productoSelected) {
        _hayProductos = true;
        return false;
      }
      return true;
    });

    // determino si hay lentes de contacto y si al menos hay uno seleccionado
    let _hayLentesContacto = false;
    lentesContactoRows.every((item) => {
      if (item.lenteContactoSelected) {
        _hayLentesContacto = true;
        return false;
      }
      return true;
    });

    if (!_hayAnteojos && !_hayArreglos && !_hayProductos && !_hayLentesContacto) {
      // si la ga no tiene anteojos, arreglos, productos o lentes de contacto

      setMessage({
        messageText:
          "Debes agregar al menos un anteojos, arreglo, otro producto o lente de contacto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      _hayAnteojos ||
      (_hayLentesContacto &&
        (recetaLejos.lejosCheck || recetaCerca.cercaCheck || recetaIntermedia.intermediaCheck))
    ) {
      // valido datos de receta
      let _error = validarDatosReceta();

      if (!_error.error) {
        setMessage({
          messageText: _error.messageText,
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    confirmarGestionAtencion();
  };
  //
  // ################################################################################
  //
  const handleCancel = () => {
    window.close();
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (ventaConcretadaNoConcretada === "venta-concretada") {
      // si venta concretada
      // controles de venta concretada

      if (valueACAreaEntrega.id === "") {
        // si el usuario no selecciono la sucursal de entrega

        setMessage({
          messageText: "Debes seleccionar la sucursal de entrega",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
      if (fechaEntrega === null) {
        // si el usuario no selecciono la fecha de entrega

        setMessage({
          messageText: "Debes seleccionar la fecha de entrega",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {
      // si venta no concretada

      if (motivoVentaNoConcretada === "") {
        // si el usuario no selecciono el motivo de la venta no concretada

        setMessage({
          messageText: "Debes seleccionar el motivo por el que no se concretó la venta",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (emiteNoEmitePresupuesto === "emite-presupuesto" && textoPresupuesto === "") {
        // si el usuario selecciono que emite presupuesto y no escribio el texto del presupuesto

        setMessage({
          messageText: "Debes escribir el texto del presupuesto",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    let _gestionAtencion = prepararGestionAtencionObject();

    save(_gestionAtencion);
  };
  //
  // ################################################################################
  //
  const save = async (parGestionAtencion) => {

    setIsDoingSomething(true);
    const response = await saveGestionAtencion(gaAction.cu, parGestionAtencion);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        // navigate("/gestion-atencion-table");
        window.close();
      }, 1000);
    }
  };
  //
  // ################################################################################
  //
  return (
    <Paper elevation={3} sx={{ m: 1, p: 2 }}>
      <Box sx={{ m: 2 }}>

        {gaAction.cu !== "view" && (
          <Grid container spacing={2}>

            <Item label="Subtotal" value={formatMoney(subTotalGestionAtencion)} xl={2} valueAlign="right" />

            <Grid item xl={12} sm={6} md={4} lg={12}>
              <ToggleButtonGroup
                color="primary"
                value={particularObraSocial}
                exclusive={true}
                onChange={handleChangeParticularObraSocial}
              >
                <ToggleButton
                  value="particular"
                  sx={{ mr: 1 }}
                  size="medium"
                  disabled={disabledGestionParticularObraSocial}
                >
                  Gestión Particular
                </ToggleButton>
                <ToggleButton
                  value="obra-social"
                  size="medium"
                  disabled={disabledGestionParticularObraSocial}
                >
                  Gestión de Obra Social
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={12}>
              <TextField
                sx={{ width: "20%" }}
                inputProps={{ style: { textAlign: "right" } }}
                id="totalFinalGestionAtencion"
                label="Importe Final"
                variant="outlined"
                size="small"
                name="totalFinalGestionAtencion"
                value={totalFinalGestionAtencion.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                onChange={handleChangeFinalizar}
                onBlur={handleBlurFinalizar}
                disabled={disabledTotalFinalGestionAtencion}
              />
            </Grid>

            {gaAction.cu !== "view" && (
              <>
                <Grid item xs={12} sm={6} md={4} lg={10}>
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    size="medium"
                    onClick={handleClickConfirmarGestionAtencion}
                    startIcon={<Check />}
                    disabled={disabledConfirmarGestionAtencion}
                  >
                    Confirmar Gestión de Atención
                  </Button>

                  <Button
                    sx={{ mr: 1 }}
                    size="medium"
                    variant="contained"
                    onClick={modificarGestionAtencion}
                    startIcon={<EditIcon />}
                    disabled={disabledModificarGestionAtencion}
                  >
                    Modificar Gestión de Atención
                  </Button>
                </Grid>
              </>
            )}

            {gestionAtencionConfirmada && (
              <>
                <Grid item xs={12} sm={6} md={4} lg={12}>
                  <Box sx={{ mt: 2 }}>
                    <ToggleButtonGroup
                      color="primary"
                      size="medium"
                      value={ventaConcretadaNoConcretada}
                      exclusive={true}
                      onChange={handleChangeVentaConcretadaNoConcretada}
                      disabled={gaAction.cu === "view"}
                    >
                      <ToggleButton
                        value="venta-concretada"
                        sx={{ mr: 1 }}
                        size="medium"
                        disabled={disabledVentaConcretadaNoConcretada}
                      >
                        Venta Concretada
                      </ToggleButton>

                      <ToggleButton
                        value="venta-no-concretada"
                        disabled={disabledVentaConcretadaNoConcretada}
                      >
                        Venta No Concretada
                      </ToggleButton>
                    </ToggleButtonGroup>

                    {ventaConcretadaNoConcretada === "venta-concretada" && (
                      <Grid container spacing={1} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <Autocomplete
                            id="id-area-entrega"
                            size="small"
                            width="100%"
                            value={
                              valueACAreaEntrega && valueACAreaEntrega.id
                                ? valueACAreaEntrega
                                : null
                            }
                            onChange={(event, newValue) => {
                              setvalueACAreaEntrega(newValue);
                              handleChangeFinalizar(event, newValue);
                            }}
                            inputValue={inputvalueACAreaEntrega}
                            onInputChange={(event, newInputValue) => {
                              setInputvalueACAreaEntrega(newInputValue);
                            }}
                            options={areas}
                            getOptionLabel={(option) => option.descripcion || ""}
                            renderInput={(params) => (
                              <TextField {...params} label="Sucursal de entrega" />
                            )}
                            isOptionEqualToValue={(option, value) => {
                              if (!value || !value.id) return false;
                              return option.id === value.id;
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <DatePicker
                            sx={{
                              width: "50%",
                              mb: 1,
                              "& .MuiInputLabel-root": {
                                transform: "translate(14px, 9px) scale(1)",
                              },
                              "& .MuiInputBase-root": {
                                paddingRight: "10px",
                              },
                              "& .MuiInputLabel-shrink": {
                                transform: "translate(14px, -8px) scale(0.75)",
                              },
                            }}
                            id="fechaEntrega"
                            label="Fecha de Entrega"
                            variant="outlined"
                            name="fechaEntrega"
                            value={fechaEntrega}
                            format="dd/MM/yyyy"
                            minDate={(gaAction.cu === "new" || gaAction.cu === "update") ? new Date() : null}
                            onChange={(newValue) =>
                              handleChangeFechaEntrega(newValue)
                            }
                            slots={{ textField: TextField }}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}

                    {ventaConcretadaNoConcretada === "venta-no-concretada" && (
                      <Grid container spacing={1} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <FormControl
                            sx={{ width: "100%" }}
                            disabled={gaAction.cu === "view"}
                          >
                            <InputLabel id="motivo-venta-no-concretada-label">
                              Motivo de venta no concretada
                            </InputLabel>
                            <Select
                              labelId="motivo-venta-no-concretada-label"
                              label="Motivo de venta no concretada"
                              id="motivo-venta-no-concretada-select"
                              name="motivoVentaNoConcretada"
                              value={motivosVentaNoConcretada.length > 0 ? motivoVentaNoConcretada : ""}
                              size="small"
                              onChange={handleChangeFinalizar}
                            >
                              {motivosVentaNoConcretada.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.descripcion}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <TextField
                            sx={{ width: "100%" }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            id="detalleVentaNoConcretada"
                            label="Detalle de venta no concretada"
                            variant="outlined"
                            size="small"
                            name="detalleVentaNoConcretada"
                            value={detalleVentaNoConcretada}
                            onChange={handleChangeFinalizar}
                            disabled={gaAction.cu === "view"}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={12}>
                          <ToggleButtonGroup
                            sx={{ mt: 1 }}
                            color="primary"
                            size="small"
                            value={emiteNoEmitePresupuesto}
                            exclusive={true}
                            onChange={handleChangeEmiteNoEmitePresupuesto}
                            disabled={gaAction.cu === "view"}
                          >
                            <ToggleButton sx={{ mr: 1 }} value="emite-presupuesto">
                              Emitir Presupuesto
                            </ToggleButton>

                            <ToggleButton value="no-emite-presupuesto">
                              No Emitir Presupuesto
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={12}>
                          {emiteNoEmitePresupuesto === "emite-presupuesto" && (
                            <>
                              <Box sx={{ mt: 2 }}>
                                <TextareaAutosize
                                  sx={{ mb: 1 }}
                                  style={{ width: "80%" }}
                                  id="textoPresupuesto"
                                  variant="outlined"
                                  minRows={20}
                                  maxRows={20}
                                  name="textoPresupuesto"
                                  value={textoPresupuesto}
                                  onChange={handleChangeFinalizar}
                                  disabled={gaAction.cu === "view"}
                                />
                              </Box>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </Box>

                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
                  >
                    {gaAction.cu !== "view" && (_crearGestionAtencion || _editarGestionAtencion) && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          size="medium"
                          onClick={handleSave}
                          disabled={disabledGuardarGA}
                          startIcon={<SaveIcon />}
                        >
                          GUARDAR GESTIÓN DE ATENCIÓN
                        </Button>
                      </>
                    )}

                    <Button
                      sx={{ ml: 1 }}
                      variant="outlined"
                      size="medium"
                      onClick={handleCancel}
                      startIcon={<CancelIcon />}
                    >
                      {gaAction.cu !== "view" ? "Cancelar" : "Cerrar"}
                    </Button>
                  </Box>
                </Grid>
              </>
            )}

            {/* >>>> Messages */}

            {showMessage && (
              <Message
                showMessage={showMessage}
                setShowMessage={setShowMessage}
                message={message}
              />
            )}
          </Grid>
        )}

        {gaAction.cu === "view" && (
          <Grid container spacing={2} >
            <Item label="Sucursal" value={sucursalGA} />
            <Item label="Creada el" value={fechaCreacionGA} />
            <Item label="Vendedor" value={usuarioGA} />
            <Item label="Tipo de Gestión de Atención" value={particularObraSocial === "particular" ? "Particular" : "Obra Social"} />
            <Item label="Precio de venta total de lista" value={formatMoney(totalFinalGestionAtencion)} />
            <Item label="Venta concretada / NO concretada" value={ventaConcretadaNoConcretada === "venta-concretada"
              ? "Concretada"
              : "NO Concretada"} />

            {ventaConcretadaNoConcretada === "venta-concretada" && (
              <>
                <Item label="Sucursal de Entrega" value={descripcionAreaEntrega} />
                <Item label="Fecha de Entrega" value={format(fechaEntrega, "dd/MM/yyyy")} />
              </>
            )}

            {ventaConcretadaNoConcretada === "venta-no-concretada" && (
              <>
                <Item label="Motivo de venta no concretada" value={descripcionMotivoVentaNoConcretada} />
                <Item label="Detalle de venta no concretada" value={detalleVentaNoConcretada} />
                <Item label="Presupuesto" value={emiteNoEmitePresupuesto === "emite-presupuesto"
                  ? "Se entregó presupuesto"
                  : "NO se entregó presupuesto"} />

                {emiteNoEmitePresupuesto === "emite-presupuesto" && (
                  <Item label="Texto del Presupuesto" value={textoPresupuesto} />
                )}
              </>
            )}
          </Grid>
        )}
      </Box>
    </Paper>
  );
};
export default Finalizar;
